export default {
  pwmatgpu: {
    banner: 'Software Download',
    title: 'GPU card UUID authentication LICENSE version',
    describe: `
    The installation packages listed below all use the GPU card UUID to authenticate the LICENSE.
    Longxun generates the certificate file pwmat.lic based on the UUID provided by the user.
    The certificate file needs to be placed in the server /opt/pwmat/ folder.
    PWmat goes back to this folder by default to read the LICENSE file.
    If the user does not have root permissions on the server and
    cannot place the certificate file in the /opt/pwmat/ directory,
    you can specify the folder where the LICENSE file is located
    after PWmat with the -lic-path parameter when running PWmat: PWmat -lic-path 'path-to-pwmat.lic'.
    Except for supercomputing centers and large-scale clusters,
    most users download this version for software installation or update.
    Before downloading the PWmat installation package, please first confirm the MPI and CUDA versions
    on your server and download the installation package according to the corresponding relationship.
    If you have any unclear operation, please contact Longxun staff in time or send an email to support@pwmat.com! ! !
    `,
    tableR0C1: 'CUDA Version',
    tableR0C2: 'MPI Version',
    tableR0C3: 'PWmat Version',
    tableR0C4: 'Installing Packages',
    tableR0C5: 'Update time',
    note: 'Note',
    note1: 'PWmat Installation Instructions',
    note2: 'How to get GPU UUID',
    note3: 'Download historical versions',
    title2: 'Start server.py service authentication LICENSE version',
    describe2: `
    The installation packages listed below all use the method of authenticating LICENSE by starting
    the server.py service in the cluster login or management node. Users of supercomputing centers
    or large-scale clusters download this version for software installation or update. Before
    downloading the PWmat installation package, please first confirm the MPI and CUDA versions
    on your server and download the installation package according to the corresponding relationship.
    Special attention should be paid to the fact that when running this version of PWmat,
    the IP and communication port of the node where the server.py service is deployed need to be specified in PWmat.
    For the IP and communication port setting methods, please refer to the server.py service installation instructions ! ! !
    `,
    note22: 'Server.py service installation instructions',
  },
  pwmatdcu: {
    title: 'DCU Version',
    describe: `
    The DCU version of PWmat installation package uses the method of logging in to the cluster
    or starting the server.py service to authenticate the LICENSE. Before downloading
    the PWmat installation package, please first confirm the DTK, MKL library,
    MPI and gcc versions on your server, and download the installation package according to the corresponding relationship.
    `,
    tableR0C1: 'DTK version',
    tableR0C2: 'MPI and gcc version',
  },
  pwmatcpu: {
    title: 'CPU Version',
    describe: `
    The CPU version of the PWmat installation package uses the method of logging in to the cluster or
    starting the server.py service to authenticate the LICENSE. Before downloading the PWmat installation package,
    please first confirm the MKL library and MPI version on your server and download the installation package according to the corresponding relationship.
    `,
    tableR0C1: 'CPU architecture',
    tableR0C2: 'MKL and MPI versions',
  },
  pwmatwin: {
    title: 'Windows version',
    describe: `
    For the Windows version, PWmat currently only supports self-consistent calculations (JOB=SCF),
    non-self-consistent calculations (JOB=NONSCF), density of states calculations (JOB=DOS),
    atomic position optimization calculations (JOB=RELAX) and molecular dynamics calculations (JOB=MD).
    It does not support the addition of VDW and LDA+U corrections.
    `,
    tableR0C1: 'Version',
    tableR0C2: 'release date',
    tableR0C3: 'Download winpwmat graphical interface version',
    tableR0C4: 'Function Introduction',
    tableR1C3: 'Download the installation package',
  }
}